import { pdfjs } from 'react-pdf';

// Set the workerSrc to the correct path of the worker script in the public directory
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;
